//colors object
export default {
  layout: {},
}
